<!-- Intermediate popup for selecting XLS or CSV for downloading line-details-->
<div id="managePopUp">

<div class="modal-header">
	<div class='modal-title'>{{header}}</div>
	<button type="button" class="close" aria-label="Close" (click)="closeModal()">
		<span aria-hidden="true">&times;</span>
	  </button>       
  </div>
  <div class="modal-body" *ngIf="!isGlossary">
    <div>
		<p>{{content}}</p>
    </div>
    <div class="download-active" *ngIf="showActiveLineOptn">
      <mat-checkbox  [(ngModel)]="isActiveChbxSelected" (change)=onClickActive($event)></mat-checkbox>
      <p class="active-line-text" (click)="onClickActive()">{{authoringContentData?.manageLine?.downloadActive}}</p>
    </div>
  </div>
  <div class="modal-body" *ngIf="isGlossary">
    <div class="row glossary-data-header">
      <div class="col-4 glossary-modal-val">{{authoringContentData?.manageLine?.header}}</div> 
      <div class="col-8 glossary-modal-val">{{authoringContentData?.manageLine?.definition}}</div>
    </div> 
    <div class="row glossary-data">
      <div class="col-4 glossary-modal-key">{{authoringContentData?.manageLine?.ans5GText}}</div> 
      <div class="col-8 glossary-modal-val">{{authoringContentData?.manageLine?.ans5GDef}}</div>
    </div> 
    <div class="row glossary-data">
      <div class="col-4 glossary-modal-key">{{authoringContentData?.manageLine?.bssText}}</div> 
      <div class="col-8 glossary-modal-val">{{authoringContentData?.manageLine?.bssDef}}</div>
    </div> 
    <div class="row glossary-data">
      <div class="col-4 glossary-modal-key">{{authoringContentData?.manageLine?.mecText}}</div> 
      <div class="col-8 glossary-modal-val">{{authoringContentData?.manageLine?.mecDef}}</div>
    </div> 
    <div class="row glossary-data">
      <div class="col-4 glossary-modal-key">{{authoringContentData?.manageLine?.mrcText}}</div> 
      <div class="col-8 glossary-modal-val">{{authoringContentData?.manageLine?.mrcDef}}</div>
    </div>
  </div>
  <div class="modal-footer pb-5 justify-content-end" *ngIf="!isGlossary && noDwnldButton">
    <button type='button' class='primary_btn' id='linedetails-xls-btn' (click)="downloadExcel()">{{authoringContentData?.manageLine?.dowwnloadModalXlsButton}}</button>
    <button type='button' class='primary_btn' id='linedetails-csv-btn' (click)="downloadCsv()">{{authoringContentData?.manageLine?.downloadModalCsvButton}}</button>
  </div>

</div>